import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, TextField, Alert } from "@mui/material";

const StartEndDateFields = ({ form, setForm }) => {
  const [error, setError] = useState("");

  const startDate = form.conditions?.startDate || "";
  const endDate = form.conditions?.endDate || "";

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      conditions: {
        ...prev.conditions,
        [field]: value,
      },
    }));
  };

  useEffect(() => {
    if (!startDate || !endDate) {
      setError("Both start and end dates are required.");
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start > end) {
      setError("Start date must be before or equal to end date.");
    } else {
      setError("");
    }
  }, [startDate, endDate]);

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography variant="subtitle1" gutterBottom sx={{ mb: 2 }}>
        Schedule
      </Typography>

      {error && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="datetime-local"
            label="Start Date & Time"
            InputLabelProps={{ shrink: true }}
            value={startDate.slice(0, 16)}
            onChange={(e) => handleChange("startDate", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="datetime-local"
            label="End Date & Time"
            InputLabelProps={{ shrink: true }}
            value={endDate.slice(0, 16)}
            onChange={(e) => handleChange("endDate", e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StartEndDateFields;
